import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Subject, Subscription} from "rxjs";
import {TabVo} from "../../../shared/models/tab-vo";
import {EnquadradaFiltroComponent} from "../enquadrada-filtro/enquadrada-filtro.component";
import {EnquadradaModel} from "../enquadrada-filtro/EnquadradaModel";
import {DashboardService} from "../../dashboard.service";
import {ToastService} from "maps-angular-components";
import {EnquadradaDesenquadradaOutput} from "../enquadrada-filtro/EnquadradaDesenquadradaOutput";
import {indicate} from "../../../shared/util/loading-indicate";
import {MaskUtil} from "../../../shared/util/mask-util";
import { CardType } from "../../cards/card-type";

@Component({
  selector: 'app-cancelada',
  templateUrl: './cancelada.component.html',
  styleUrls: ['./cancelada.component.scss']
})
export class CanceladaComponent implements OnInit, AfterViewInit, OnDestroy {

  private subscriptions = new Subscription();

  @Input() pageCadastroVO: TabVo;

  @ViewChild("filtroComponent", { static: false })
  filtroComponent: EnquadradaFiltroComponent;

  page$: Subject<number> = new Subject<number>();

  @Output()
  private afterViewInit: EventEmitter<TabVo> = new EventEmitter<TabVo>();
  cardType: CardType;
  CardType = CardType;
  paginationTotalPage: number = 1;
  totalRegistros: number = 0;
  loading$ = new Subject<boolean>();
  enquadradaModel: EnquadradaModel[] = [];

  constructor(
    private dashboardService: DashboardService,
    private messageService: ToastService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit(): void {
    let output = new EnquadradaDesenquadradaOutput();

    this.subscriptions.add(
      this.dashboardService.getUltimaDataProcessamento().subscribe(
        res => {
          if (res !== null && res) {
            output.dataUltimoProcessamento = res;
          }
          this.filtroComponent.setData(res);
          this.pesquisar(output);
        })
    );
  }

  pesquisar(value: EnquadradaDesenquadradaOutput, page = 1) {
    value.page = page - 1;
    this.enquadradaModel = [];
    this.totalRegistros = 0;

    this.subscriptions.add(
      this.dashboardService
        .findCarteirasByStatusCanceladas(value)
        .pipe(
          indicate(this.loading$),
          indicate(this.filtroComponent.loading$)
        )
        .subscribe(
          (r) => {
            let metadata = r.metadata;
            if (metadata.totalElements > 0) {
              if (metadata.totalPages === 0) {
                this.paginationTotalPage = 1;
              } else {
                this.paginationTotalPage = Math.ceil(
                  metadata.totalElements / metadata.size
                );
              }
              this.totalRegistros = metadata.totalElements;
              this.enquadradaModel = r.content.map((e) =>
                Object.assign(new EnquadradaModel(), e)
              );
            } else {
              this.paginationTotalPage = 1;
            }
          },
          err => this.messageService.erro(err.error?.message || err.message)
        )
    );
  }

  receiverPage(value: any) {
    this.pesquisar(this.filtroComponent.getOutputNoInput(), value);
  }

  searchEvent(pageNumber: number) {
    this.page$.next(pageNumber);
  }

  public formatCnpj(cnpj: string) {
    return MaskUtil.formatCnpj(cnpj);
  }
}
